<template>

  <div>

    <div v-for="(item, n) in value" :key="n" class="mb-1">

      <day-hours-editor v-model="value[n]" :is-calendar="true" @remove="removeDay(n)" />

    </div>

    <el-button type="text" @click="addDay">Add day</el-button>

  </div>

</template>
<script>
  import DayHoursEditor from './DayHoursEditor';
  export default {
    props: ['value'],
    components: {
      DayHoursEditor
    },
    mounted() {

    },
    methods: {
      addDay() {
        this.value.push({
          date: new Date(),
          hours: [{opens: '09:00', closes: '18:00'}],
          isOpen: true
        });
      },
      removeDay(index) {
        this.value.splice(index, 1);
      }
    }
  };
</script>



// WEBPACK FOOTER //
// SpecialHoursEditor.vue?39af20fc